// extracted by mini-css-extract-plugin
module.exports = {"pricingPlanInfo":"ob_BfKxWH","pricingPlanInfo__icon":"ob_JsJuMp"};